import React from 'react';
import PropTypes from 'prop-types';
import classes from './Subtitle.module.scss';

const Subtilte = ({ children }) => (
  <h2 className={classes.subtitle}>{children}</h2>
);

Subtilte.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Subtilte;
